export default "__VITE_ASSET__CRoJoMPC__"